function SearchOPBC() {

  return (
    <div>
      <div className='greenBar'>BUBONIC CURTSY FILES</div>

      <div className='searchBody'>
        <br/>
        Operation Bubonic Curtsy mission files have been deemed CLASSIFED on the grounds that they make Agent Papyrus look... not great.
        <br/><br/>
        They can be found <a style={{color:'#f9df39'}} href='./opbc' target='_blank'>here</a>. (password required). Only Agent Papyrus has this password, which he keeps in his office.
      </div>

    </div>
  )
}

export default SearchOPBC;